import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSDataGridNew from "../../../Components/DataGrid/WSDataGridNew";
import WSButton from "../../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import AddIcon from '@mui/icons-material/Add';
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

export const BrandList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
   const params = useParams();
    const id = params?.id;
    
const filters = ['All Records'];
       const [selectedFilter, setSelectedFilter] = useState(filters[0]);

        const [productSource, setProductSource] = useState<any>({
               url: "Brand/search",
               page: 1,
               pageSize: 10,
               filter: [
               ],
               sort: [
                 
               ],
           })
  const source = {
    url: "Brand/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };

  useEffect(()=>{
        updateMainHeader('Brand');
      })

       breadCrumbsStore.updateBreadCrumbs([
                  { 'Brand List': '/brand/list' },
              ]);
                 
  const handleFilter = (value: any) => {
        let soureFilter: any = {
            url: "Brand/search",
            page: 1,
            pageSize: 10,
            filter: [
            ],
            sort: [
                {
                    "field": "UpdatedAt",
                    "direction": "desc"
                }
            ],
        }
        switch (value) {
            case 'In Stock':
                soureFilter.filter = [{
                    "field": "name",
                    "operator": "eq",
                    "value": "In Stock"
                }]
                break

        }
      //  setProductSource({ ...soureFilter });
    }

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/brand/edit/${row?.id}`);
    }

    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "name",
      tooltip: true,
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action, row) => handleAction(action, row),
    },
  ];

  const handleClick = () => {
    navigate("/brand/create");
  };
  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("brandGrid"));
    showMessage("Brand deleted successfully!", "success");
  };
  return (
    // <Grid p={3}>
    //   <Grid container spacing={2}>
    //     <Grid item xs={12}>
    //       <WSDataGrid
    //         id="brandGrid"
    //         title="Brand"
    //         columns={columns}
    //         source={source}
    //         addButton={{ label: "New", color: "secondary" }}
    //         onAddButtonClick={handleClick}
    //         gridHeaderSx={{
    //           backgroundColor: "whitesmoke",
    //           border: "1px solid whitesmoke",
    //         }}
    //       />
    //       {selectedId !== null && (
    //         <ConfirmationPopup
    //           apiUrl={"Brand"}
    //           type="DELETE"
    //           id={selectedId}
    //           confirmMessage="Are you sure you want to delete this item?"
    //           open={isPopupOpen}
    //           onClose={() => setPopupOpen(false)}
    //           onConfirm={handleDelete}
    //         />
    //       )}
    //     </Grid>
    //   </Grid>
    // </Grid>

     <Grid p={3}>
      <Grid container spacing={2}>
             <Grid item sm={9}>
                    <WSFilterButtonGroup options={filters} selected={selectedFilter}
                        onChange={(value) => {
                            setSelectedFilter(value);
                            handleFilter(value);
                        }} />
                </Grid>
         <Grid item sm={3} display="flex" justifyContent={'flex-end'}>
                    <WSButton id="btnAddNewProduct" label="Add Brand" startIcon={<AddIcon />} 
                    onClick={handleClick}
                    sx={{
                        borderRadius: '999px',         // pill shape
                        backgroundColor: '#098963!important',    // green background
                        textTransform: 'none',         // prevent uppercase
                        fontWeight: 500,
                        height: '35px!important',
                        fontSize: '0.875rem!important',
                        paddingX: 3,
                        paddingY: 1,
                        '&:hover': {
                            backgroundColor: '#087654!important',
                        },
                    }} />
                </Grid>
        <Grid item xs={12}>
         {productSource&& <WSDataGridNew
            id="brandGrid"
            title="Brand"
            columns={columns}
            source={productSource}
             searchBox={{ fieldName: 'name' }}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
}
          {selectedId !== null && (
            <ConfirmationPopup
              apiUrl={"Brand"}
              type="DELETE"
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
